import Home from '../pages/home'
import UserManagement from '../pages/admin/users';
import UserForm from '../pages/admin/users/user-form.js';
import CommodityType from '../pages/references/commodity-types';
import CommodityTypeForm from '../pages/references/commodity-types/commodity-type-form';
import Documents from '../pages/templates/documents';
import DocumentForm from '../pages/templates/documents/document-form';
import IncoTerms from '../pages/references/inco-terms';
import IncoTermForm from '../pages/references/inco-terms/inco-term-form';
import Countries from '../pages/references/countries';
import CountryForm from '../pages/references/countries/country-form';
import Sections from '../pages/templates/sections';
import SectionForm from '../pages/templates/sections/section-form';
import Statements from '../pages/templates/statements';
import StatementForm from '../pages/templates/statements/form';
import StatementCreateForm from '../pages/templates/statements/createForm';
import DocumentSets from '../pages/templates/document-sets';
import DocumentSetForm from '../pages/templates/document-sets/template-form';
import PartnerSites from '../pages/references/partner-sites';
import ShippingInstructions from '../pages/shipping-instructions';
import ShippingInstructionFormContainer from '../pages/shipping-instructions/shipping-instruction-form-container';
import ShippingInstructionPrint from '../pages/shipping-instructions/shipment-instruction-print';
import Consignees from '../pages/references/consignees';
import ConsigneeForm from '../pages/references/consignees/consignee-form';
import PartnerSiteForm from '../pages/references/partner-sites/partner-site-form';
import ShipToMapping from '../pages/integrations/Ship-to-mappings';
import PerformanceDashboard from '../pages/Performance';
import ShipToMappingForm from '../pages/integrations/Ship-to-mappings/form.js';
import {GasMenuRoutes} from '../pages/gas/shared/routes';
import {
    Settings,
    Layout,
    Database,
    List,
    Crosshair,
    Activity
} from "react-feather";

import React from 'react';
import InvoiceTrackerForm from '../pages/integrations/onecp/invoice-tracker/form.js';
import InvoiceTracker from '../pages/integrations/onecp/invoice-tracker/index.js';
import ProjectCodeTrackerForm from '../pages/integrations/onecp/project-code/form.js';
import ProjectCodeTracker from '../pages/integrations/onecp/project-code/index.js';


export const ShippingInstructionRoutes = {
    id: "Shipping Instructions",
    path: "/shipping-instruction",
    right: ['ROLE_SI_USER'],
    icon: <List/>,
    multiChild: true,
    children: [
        {path: "/shipping-instructions", component: ShippingInstructions, name: "Shipping Instructions"},
    ],
    innerParent: [{ 
    id: "Templates",
    path: "/templates",
    right: ['ROLE_SI_ADMIN'],
    icon: <Layout/>,
    children: [
        {path: "/templates/documents", component: Documents, name: "Documents"}
        , {path: "/templates/document-sets", component: DocumentSets, name: "Document Sets"}
        , {path: "/templates/statements", component: Statements, name: "Statements"}
        , {path: "/templates/sections", component: Sections, name: "Sections"}
    ], component: null},
    {
        id: "References",
        path: "/references",
        icon: <Database />,
        right: ['ROLE_SI_ADMIN'],
        children: [
            {path: "/references/inco-terms", component: IncoTerms, name: "Inco Terms"}
            ,{path: "/references/commodity-types", component: CommodityType, name: "Commodity Types"}
            ,{path: "/references/countries", component: Countries, name: "Countries"} 
            , {path: "/references/consignees", component: Consignees, name: "Consignees"}                  
            , {path: "/references/partner-site", component: PartnerSites, name: "Partner Sites (Ship-to)"}
        ]
    }]
        
    
}

export const IntegrationsRoute = {
      id: "Integrations",
      path: "integrations",
      right: ['ROLE_ONECP_ADMIN','ROLE_ONECP_USER','ROLE_INT_USER'],
      icon: <Crosshair />,
      children: [
        {path: "/integrations/onecp/invoiceTracker", component: InvoiceTracker, name:"OneCP Invoice Tracker"},
        {path: "/integrations/onecp/projectCodeTracker", component: ProjectCodeTracker, name:"Project/Budget Tracker"},
        {path: "/integrations/shipToMapping", component: ShipToMapping, name:"Ship-to Mapping"}
    ]
      
}


export const PerformanceRoute = {
    id: "Performance",
    path: "performance",
    right: ['ROLE_STATUS_USER'],
    icon: <Activity />,
    children: [
      {path: "/performance/dashboard", component: PerformanceDashboard, name:"Performance Dashboard"}]
    
}

export const SiTemplates = {
    id: "Templates",
    path: "/templates",
    right: ['ROLE_SI_ADMIN'],
    icon: <Layout/>,
    children: [
        {path: "/templates/documents", component: Documents, name: "Documents"}
        , {path: "/templates/document-sets", component: DocumentSets, name: "Document Sets"}
        , {path: "/templates/statements", component: Statements, name: "Statements"}
        , {path: "/templates/sections", component: Sections, name: "Sections"}
    ], component: null
}

export const SiReferences = {
    id: "References",
    path: "/references",
    icon: <Database />,
    right: ['ROLE_SI_ADMIN'],
    children: [
        {path: "/references/inco-terms", component: IncoTerms, name: "Inco Terms"}
        ,{path: "/references/commodity-types", component: CommodityType, name: "Commodity Types"}
        ,{path: "/references/countries", component: Countries, name: "Countries"} 
        , {path: "/references/consignees", component: Consignees, name: "Consignees"}                  
        , {path: "/references/partner-site", component: PartnerSites, name: "Partner Sites (Ship-to)"}
    ]
}

export const Administrative = {
    id: "Administrative",
    path: "/admin",
    icon: <Settings />,
    right: ['ROLE_ADMIN'],
    children: [
        {path: "/admin/users", component: UserManagement, name: "User Management"}
    ]
}

export const FormRoutes = {
    children: [
        {path: "/", component: Home, name: "Home"},
        {path: "/home", component: Home, name: "Home"},
        {path: "/references/commodity-type/:id", component: CommodityTypeForm, name: "Commodity Type"}
        , {path: "/references/consignee/:id", component: ConsigneeForm, name: "Consignee"}
        , {path: "/references/inco-term/:id", component: IncoTermForm, name: "Inco Term"}
        , {path: "/references/country/:id", component: CountryForm, name: "Country"}
        , {path: "/references/partner-site/:id", component: PartnerSiteForm, name: "Partner Site"}
        , {path: "/templates/document/:id", component: DocumentForm, name: "Document"}
        , {path: "/templates/statement/:id", component: StatementForm, name: "Statement"}
        , {path: "/templates/statements/new", component: StatementCreateForm, name: "Statement"}
        , {path: "/templates/section/:id", component: SectionForm, name: "Section"}
        , {path: "/templates/document-set/:id", component: DocumentSetForm, name: "Document Set"}
        , {
            path: "/shipping-instruction/:id",
            component: ShippingInstructionFormContainer,
            name: "Shipping Instruction"
        },
        {
            path: "/shipping-instruction-print/:id",
            component: ShippingInstructionPrint,
            name: "Print Shipping Instruction"
        },
        {path: "/integrations/shipToMapping/:id", component: ShipToMappingForm, name: "Ship to Mapping Form"},
        {path: "/integrations/onecp/invoiceTracker/:id", component: InvoiceTrackerForm, name: "Invoice tracker Form"},
        {path: "/integrations/onecp/projectCode/:id", component: ProjectCodeTrackerForm, name: "Project/Budget Form"},
        {path: "/admin/user/:id", component: UserForm, name: "User Form"}
    ]
}


export const sidebarRoutes = [
    GasMenuRoutes,
    ShippingInstructionRoutes,
    IntegrationsRoute,
    PerformanceRoute,
   // SiTemplates,
   // SiReferences,
    Administrative
]